/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cc30cca446ee2bc7bd4f679561c5adc>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const LayoutThreeColumnsIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "LayoutThreeColumnsIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var _default = exports.default = LayoutThreeColumnsIcon;